/* eslint-disable react/no-danger */

import React from 'react';
import './BbAttribution.css';

class Attribution extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.wikiAttribution !== this.props.wikiAttribution;
  }

  // eslint-disable-next-line class-methods-use-this
  noTags(str) {
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '');
  }

  render() {
    // eslint-disable-next-line no-console
    console.log('*** ATTRIBUTION ***');

    const wikiO = this.props.wikiAttribution;

    if (wikiO.attribution === undefined) {
      return 'NOTICE: No attribution found.';
    }
    if (wikiO.attribution.attributionJson.query.pages['-1'] === undefined) {
      return 'NOTICE: No attribution assigned.';
    }

    let objectName = '';
    let oDateTime = '';
    let credit = '';
    let artist = '';
    let imageDescripton = '';
    let lic1of2 = '';
    let lic2of2 = '';
    let terms1of2 = '';
    let terms2of2 = '';
    let usageTerms = '';

    try {
      objectName = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.ObjectName.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.ObjectName.value,
        ) : '?';
    } catch (error) {
      console.log('NOTICE: No Name. Attribution 51');
    }

    try {
      oDateTime = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.DateTime.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.DateTime.value,
        )
        : 'FAIL oDateTime';
    } catch (error) {
      console.log('NOTICE: No date time. Attribution 63');
    }

    // Image Description
    try {
      imageDescripton = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.ImageDescription.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.ImageDescription.value,
        )
        : 'FAIL imageDescripton';
    } catch (error) {
      console.log('NOTICE: No Image Description. Attribution 76');
    }

    // Credit
    try {
      credit = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.Credit.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.Credit.value,
        )
        : '';
    } catch (error) {
      console.log('NOTICE: No Credit. Attribution 89');
    }

    // Artist
    try {
      artist = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.Artist.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.Artist.value,
        )
        : '';
    } catch (error)
    {
      console.log('Notice: No Artist in Attribution');
    }

    // License Short Name
    try {
      lic1of2 = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.LicenseShortName.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.LicenseShortName.value,
        )
        : '';
    } catch (error) {
      console.log('Notice: No License in Attribution');
    }

    try {
      lic2of2 = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.LicenseShortName.source !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.LicenseShortName.source,
        )
        : '';
    } catch (error) {
      console.log('Notice: No License #2 in Attribution');
    }

    const licenseShortName = `${lic1of2} source: ${lic2of2}`;

    // Usage Terms
    try {
      terms1of2 = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.UsageTerms.value !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.UsageTerms.value,
        )
        : '';
    } catch (error) {
      console.log('Notice: No Usage Terms in Attribution');
    }

    try {
      terms2of2 = wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
        .extmetadata.UsageTerms.source !== undefined
        ? this.noTags(
          wikiO.attribution.attributionJson.query.pages['-1'].imageinfo[0]
            .extmetadata.UsageTerms.source,
        )
        : '';
    } catch (error) {
      console.log(`ERROR --> ${error}`);
    }

    usageTerms = `${terms1of2} source: ${terms2of2}`;

    return (
      <div>
        <h5 className="text-primary">Attribution</h5>
        <div className="bb-attribution">
          <ul className="bb-attribution-list">
            <li
              id="bb-li-name"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: objectName }}
            />

            <li
              id="bb-li-date"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: oDateTime }}
            />

            <li
              id="bb-li-desc"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: imageDescripton }}
            />

            <li
              id="bb-li-credit"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: credit }}
            />

            <li
              id="bb-li-artist"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: artist }}
            />

            <li
              id="bb-li-lic"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: licenseShortName }}
            />

            <li
              id="bb-li-usage"
              className="bb-attribution-list-item"
              dangerouslySetInnerHTML={{ __html: usageTerms }}
            />
          </ul>
        </div>
      </div>
    );
  }
}

export default Attribution;
